import React, { Component } from 'react';
import {NavBar, List, Flex, Icon} from "antd-mobile";
export default class Location extends Component {
  constructor (props) {
    super(props);
    this.state = {}
  }
 render() {
    const {current} = this.props;
  return (
    <React.Fragment>
      <NavBar mode="light">批次列表</NavBar>
      <List>
        {this.props.data.map((o,index)=> {
          return <List.Item key={index} onClick={()=>{
            this.props.selectItem(o)
          }}>
            <Flex>
              <Flex.Item>{o.nameLoc}</Flex.Item>
              {/*<Flex.Item>{o.farmOrg}</Flex.Item>*/}
              <Icon color="#108EE9"
                    type={current === o.farmOrg?'check': ''}
              />
            </Flex>
          </List.Item>
        })}
        {this.props.data.length === 0 && <div>没有数据</div>}
      </List>
    </React.Fragment>
  )
 }
}
